import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-decoration',
    templateUrl: './dlg-decoration.component.pug',
    styleUrls: ['./dlg-decoration.component.less']
})
export class DlgDecorationComponent implements OnInit {

    constructor(
        private _dialogRef: MatDialogRef<DlgDecorationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit() {
        // This is hack to close by backdrop.
        const overlayWrapper = this._dialogRef['_overlayRef'].overlayElement.parentElement;

        overlayWrapper.addEventListener('click', ({ target }) => {
            if (overlayWrapper !== target) {
                return;
            }

            this.onClose();
        });
    }

    extend($event) {
        if ($event.close) {
            const close = $event.close;
            $event.close = () => {
                close();
                this.onClose();
            };
        }

        return $event;
    }

    onClose() {
        this._dialogRef.close();
    }

    onConvert($event) {
        this.data.convert(this.extend($event));
    }

    onActivate($event) {
        this.data.activate(this.extend($event));
    }

    onDeactivate($event) {
        this.data.deactivate(this.extend($event));
    }
}
